import React from "react";
import { Row, Col } from "reactstrap";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  return (
    <Row className="justify-content-end mt-4">
      <Col xs="auto">
        <i
          className="bi bi-chevron-double-left"
          style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        ></i>
      </Col>
      <Col xs="auto">
        <span>
          Page {currentPage} of {totalPages}
        </span>
      </Col>
      <Col xs="auto">
        <i
          className="bi bi-chevron-double-right"
          style={{ cursor: currentPage === totalPages ? "not-allowed" : "pointer" }}
          onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
        ></i>
      </Col>
    </Row>
  );
};

export default Pagination;
